import Auth from '@/infrastructure/api/helper/Auth';
import {期限切れ破棄破損採用品型} from '@/type/custom/otaru/destroy/item';
import {期限切れ破棄破損採用品一覧型} from '@/type/custom/otaru/destroy/itemList';
import {期限切れ破棄破損型} from '@/type/custom/otaru/destroy/otaruDestroy';
import {期限切れ破棄破損一覧型} from '@/type/custom/otaru/destroy/otaruDestroyList';
import {期限切れ破棄破損検索条件型} from '@/type/custom/otaru/destroy/otaruDestroyListSearchCriteria';
import {検索条件型} from '@/type/custom/otaru/destroy/searchCriteria';

export default {
    async 期限切れ破棄破損を検索する(検索条件: 期限切れ破棄破損検索条件型): Promise<期限切れ破棄破損一覧型> {
        const auth = new Auth();
        const response = await auth.post('/api/custom/otaru/destroy/search', 検索条件);
        return response.data;
    },

    async 期限切れ破棄破損を取得する(期限切れ破棄破損シーケンス番号: number): Promise<期限切れ破棄破損型> {
        const auth = new Auth();
        const response = await auth.get(`/api/custom/otaru/destroy/${期限切れ破棄破損シーケンス番号}`);
        return response.data;
    },

    async 期限切れ破棄破損を登録する(期限切れ破棄破損: 期限切れ破棄破損型): Promise<void> {
        const auth =  new Auth();
        const response = await auth.post('/api/custom/otaru/destroy', 期限切れ破棄破損);
    },

    async 期限切れ破棄破損を更新する(期限切れ破棄破損: 期限切れ破棄破損型): Promise<void> {
        const auth =  new Auth();
        const response = await auth.put('/api/custom/otaru/destroy', 期限切れ破棄破損);
    },

    async 期限切れ破棄破損を削除する(期限切れ破棄破損シーケンス番号値: number, 更新バージョン値: number): Promise<void> {
        const auth = new Auth();
        await auth.put('/api/custom/otaru/destroy/remove',
            {
                期限切れ破棄破損シーケンス番号: 期限切れ破棄破損シーケンス番号値,
                更新バージョン: 更新バージョン値,
            });
    },

    async 期限切れ破棄破損採用品をJANコードから取得する(JANCode: string): Promise<期限切れ破棄破損採用品型> {
        const auth = new Auth();
        const response = await auth.get(`/api/custom/otaru/destroy/item?jan=${JANCode}`);
        return response.data;
    },

    async 期限切れ破棄破損採用品を商品コードから取得する(商品コード: string): Promise<期限切れ破棄破損採用品型> {
        const auth = new Auth();
        const response = await auth.get(`/api/custom/otaru/destroy/item?code=${商品コード}`);
        return response.data;
    },

    async 期限切れ破棄破損採用品を検索する(検索条件: 検索条件型): Promise<期限切れ破棄破損採用品一覧型> {
        const auth = new Auth();
        const response = await auth.post('/api/custom/otaru/destroy/item/search', 検索条件);
        return response.data;
    },
};
